import { render } from '../src'

render(document.getElementById('root'))